// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchAdminTrainers_root__2fCRV","table":"SearchAdminTrainers_table__35eIf"};